/**
 * Проверяет готовность книг в корзине к оформлению заказа.
 * @param {Array} cartItems — массив книг из корзины
 * @returns {string[]}
 */
export function getBooksProblems(cartItems) {
  if (!cartItems || cartItems.length === 0) {
    return ["Корзина пуста"];
  }
  return [];
}